import KnowledgeHub from './KnowledgeHub';

export default KnowledgeHub;
